<div class="loading-info">
    <span class="content">
        <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
        <h4 class="title">{{title}}</h4>
        <p class="text">{{text}}</p>    
    </span>
</div>